// mysteryBoxSizes defines the possible sizes that may be included
// in a mystery box, categorized by gender ("F" for female, "M" for male)
//  mystery box size: [sizes of components that may be placed in the box]
// Note: "N/A" and "OFSM" (One-Size-Fits-Most) are used where applicable

export const mysteryBoxSizes = {
  F: {
    XXS: ['XXS', 'XS/S', 'S/M', 'N/A', 'OFSM'],
    XS: ['XS', 'XS/S', 'S/M', 'N/A', 'OFSM'],
    S: ['S', 'XS/S', 'S/M', 'N/A', 'OFSM'],
    M: ['M', 'M/L', 'N/A', 'OFSM'],
    L: ['L', 'M/L', 'N/A', 'OFSM'],
    XL: ['XL', 'L/XL', 'XL/XXL', 'XL-XXL', 'N/A', 'OFSM'],
    'XXL-1X': ['XXL-1X', 'L/XL', 'XL-XXL', 'XL/XXL', 'N/A', 'OFSM'],
    '2X': ['2X', 'L/XL', '1X/2X', 'N/A', 'OFSM'],
    '3X': ['3X', 'L/XL', '3X/4X', 'N/A', 'OFSM'],
    '4X': ['4X', 'L/XL', '3X/4X', 'N/A', 'OFSM'],
    '5X': ['5X', 'N/A', 'OFSM'],
    '6X': ['6X', 'N/A', 'OFSM'],
  },
  M: {
    size_bottom: {
      XS: ['29 in / Regular 32 in', 'XS / Regular 29 in', 'XS'],
      S: ['30 in / Regular 32 in', 'S / Regular 29 in', 'S'],
      M: ['32 in / Regular 32 in', 'M / Regular 29 in', 'M'],
      L: ['35 in / Regular 32 in', 'L / Regular 29 in', 'L'],
      XL: ['38 in / Regular 32 in', 'XL / Regular 29 in', 'XL'],
      XXL: ['42 in / Regular 32 in', 'XXL / Regular 29 in', 'XXL'],
      '2X': ['2X / Regular 29 in', '2X'],
      '3X': ['3X / Regular 29 in', '3X'],
      '4X': ['4X / Regular 29 in', '4X'],
    },
    size_undie: {
      XS: ['XS / 5in', 'XS', 'S/M'],
      S: ['S / 5in', 'S', 'S/M'],
      M: ['M / 5in', 'M', 'S/M', 'M/L'],
      L: ['L / 5in', 'L', 'M/L', 'L/XL'],
      XL: ['XL / 5in', 'XL', 'XL', 'L/XL'],
      XXL: ['XXL / 5in', 'XXL'],
      '2X': ['2X'],
      '3X': ['3X'],
      '4X': ['4X'],
    },
    size_top: {
      XS: ['XS'],
      S: ['S'],
      M: ['M'],
      L: ['L'],
      XL: ['XL'],
      XXL: ['XXL'],
      '2X': ['2X'],
      '3X': ['3X'],
      '4X': ['4X'],
    },
    default: {
      XS: ['N/A', 'OFSM'],
      S: ['N/A', 'OFSM'],
      M: ['N/A', 'OFSM'],
      L: ['N/A', 'OFSM'],
      XL: ['N/A', 'OFSM'],
      XXL: ['N/A', 'OFSM'],
      '2X': ['N/A', 'OFSM'],
      '3X': ['N/A', 'OFSM'],
      '4X': ['N/A', 'OFSM'],
    },
  },
};
